module.exports = "https://de18y2hs3hlxs.cloudfront.net/d7023bab-6786-4218-a639-f7331314cecc/images/notepad-2.png?93936d7ca0aada75a2e9c11d9bd6e63d";